import axios from "axios";
import React, { useEffect, useState } from "react";
import { getCurrentFY } from "../../Utilitie";
import Loading from "../../Extra/Loading";
import CrewHQFilter from "./CrewHQFilter";
import LobbyWiseHQRest from "./LobbyWiseHQRest";
import MonthWiseHQRest from "./MonthWiseHQRest";
import CrewHQGraph from "./CrewHQGraph";
import SunburstChart from "../../CHARTS/SunburstChart";

const opState = {
  Year: false,
  Months: false,
  Lobby: false,
  CrewLobby: false,
};
const CrewHQMaster = () => {
  const urlPrefixBlock = process.env.REACT_APP_URL_CMS_PREFIX;
  const [hqData, setHqData] = useState(null);
  const currentYear = getCurrentFY();
  const [year, setYear] = useState(currentYear.slice(0, 4));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openStates, setOpenStates] = useState(opState);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [sunBurstChartData, setSunBurstChartData] = useState(null);
  const [selectedBar, setSelectedBar] = useState([]);
  const [selectedLineBar, setSelectedLineBar] = useState("");
  const years = Array.from(
    { length: 10 },
    (_, i) => new Date().getFullYear() - i,
  ); // last 10 years
  useEffect(() => {
    if (!selectedLineBar) return;

    setSelectedBar((prev) =>
      prev.includes(selectedLineBar) ? prev : [...prev, selectedLineBar],
    );
  }, [selectedLineBar]);

  const fetchData = async (year) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}t_outstation_crew_rest_at_hq?hq_year=${year}`,
      );

      if (response.status === 200) {
        setHqData([
          ...(response.data.current_data || []),
          ...(response.data.previous_data || []),
        ]);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(year);
  }, [year]);
  const totalOccurrence = filteredData?.reduce((sum, acc) => {
    return (sum = sum + acc.hq_occurence);
  }, 0);

  return (
    <div
      onClick={(e) => {
        if (e.target.closest(".sticky-controller")) return;
        setOpenStates(opState);
      }}
    >
      <div className=" bg-dark text-white ps-2 p-1 d-flex align-items-center justify-content-between ">
        <div>
          <h5 className="">Outstation Crew Rest At HQ {}</h5>
        </div>
        <div className="row pe-3 d-flex align-items-center">
          <b className="col-md text-end" style={{ fontSize: "18px" }}>
            Year
          </b>
          <div className="col-md">
            <select
              style={{ width: "100px", height: "35px" }}
              className="form-select"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="">--FY-- </option>
              {years.map((yr, i) => (
                <option key={yr} value={yr}>
                  {yr}-{String(yr + 1).slice(2, 4)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <>
        {loading && <Loading />}

        {hqData && (
          <div className="sticky-controller">
            <CrewHQFilter
              data={hqData}
              setSelectedFilters={setSelectedFilters}
              setFilteredData={setFilteredData}
              openStates={openStates}
              setOpenStates={setOpenStates}
            />
          </div>
        )}

        {filteredData?.length > 0 && (
          <CrewHQGraph
            data={filteredData}
            selectedBar={selectedBar}
            setSunBurstChartData={setSunBurstChartData}
            setSelectedLineBar={setSelectedLineBar}
            chartHeight={"450px"}
          />
        )}
        <div className="row">
          <div className="col-md-8">
            {filteredData?.length > 0 && (
              <LobbyWiseHQRest data={filteredData} />
            )}
          </div>
          <div className="col-md-4">
            <div className="newUiBody">
              {sunBurstChartData && (
                <SunburstChart
                  data={sunBurstChartData}
                  outerLayer={3}
                  length={totalOccurrence}
                  from={"Crew Hq Rest"}
                  chartHeight={"450px"}
                  showPercent={true}
                />
              )}
            </div>
          </div>
        </div>
        {filteredData?.length > 0 && <MonthWiseHQRest data={filteredData} />}
      </>
    </div>
  );
};

export default CrewHQMaster;
